import { render, staticRenderFns } from "./CalendarEventEditWrapper.vue?vue&type=template&id=38327b04&scoped=true"
import script from "./CalendarEventEditWrapper.vue?vue&type=script&lang=ts"
export * from "./CalendarEventEditWrapper.vue?vue&type=script&lang=ts"
import style0 from "./CalendarEventEditWrapper.vue?vue&type=style&index=0&id=38327b04&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38327b04",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38327b04')) {
      api.createRecord('38327b04', component.options)
    } else {
      api.reload('38327b04', component.options)
    }
    module.hot.accept("./CalendarEventEditWrapper.vue?vue&type=template&id=38327b04&scoped=true", function () {
      api.rerender('38327b04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/calendar/CalendarEventEditWrapper.vue"
export default component.exports